/* eslint-disable unused-imports/no-unused-vars */
import axios from '@axios'

export default {
    namespaced: true,
    state: {
        data: [],
    },
    getters: {
        getData(state) {
            return state.data
        },
    },
    mutations: {
        setData(state, data) {
            state.data = data
        },
    },
    actions: {
        consultarBodegas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/temperatura/bodegas', { params: data })
                    .then(response => {
                        //commit('setData', response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        consultarEquipos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/temperatura/equipos', { params: data })
                    .then(response => {
                        //commit('setData', response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        consultarData({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/temperatura/medidas', { params: data })
                    .then(response => {
                        commit('setData', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        consultarRango({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/temperatura/rango', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        guardarData({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/temperatura/guardar')
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
    },
}
